import { useLayoutEffect, useRef, useState } from "react";
import { useTheme } from "../../lib/theme";
import { useBannerActivity } from "./useBannerActivity";
import { useBannerScrollFade } from "./useBannerScrollFade";

import BannerRipple from "./BannerRipple";

type Props = { title: string; headingAs?: "h1" | "p" };

/** Shared section heading. Docs retains the article's own H1 below this label. */
export function SectionBanner({ title, headingAs: Heading = "h1" }: Props) {
  const ref = useRef<HTMLElement>(null);
  const theme = useTheme();
  const active = useBannerActivity(ref);
  useBannerScrollFade(ref);
  const [palette, setPalette] = useState({ ink: "", lilac: "", background: "" });
  useLayoutEffect(() => {
    if (ref.current) {
      const style = getComputedStyle(ref.current);
      setPalette({ lilac: style.getPropertyValue("--section-banner-lilac").trim(), ink: style.getPropertyValue("--section-banner-ink").trim(), background: style.getPropertyValue("--bg").trim() });
    }
  }, [theme]);
  return (
    <header className="section-banner" ref={ref}>
      <div className="section-banner-art" aria-hidden="true" data-active={active}>
        {palette.ink && <BannerRipple lilac={palette.lilac} ink={palette.ink} background={palette.background} active={active} />}
      </div>
      <div className="section-banner-center" aria-hidden="true" />
      <Heading className="section-banner-title">{title}</Heading>
    </header>
  );
}
